var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import ResultList from '../../components/console-common/table.vue';
import editRole from '../../components/auth-manage/role-manage/edit-account.vue';
import eventBus from '../../utils/fresh-table';
export default Vue.extend({
    data: function () {
        var _this = this;
        return {
            defaultSearch: {
                enable: '',
            },
            roles: [
                {
                    label: '不限',
                    val: '',
                },
            ],
            otherConfig: {
                title: '',
            },
            requestConfig: {
                url: '/proxy/auth/user/page',
                method: 'POST',
            },
            searchConfig: [
                {
                    label: '用户名',
                    key: 'username',
                    type: 'input',
                    placeholder: '请输入用户名',
                },
                {
                    label: '用户角色',
                    key: 'role',
                    type: 'select',
                    option: [],
                },
                {
                    label: '账号状态',
                    key: 'enable',
                    type: 'radio',
                    option: [
                        {
                            label: '不限',
                            val: '',
                        },
                        {
                            label: '启用中',
                            val: true,
                        },
                        {
                            label: '禁用中',
                            val: false,
                        },
                    ],
                },
            ],
            tableConfig: [
                {
                    label: '用户名',
                    prop: 'username',
                    tooltip: true,
                },
                {
                    label: '昵称',
                    prop: 'nickname',
                    tooltip: true,
                },
                {
                    label: '用户角色',
                    prop: 'roles',
                    tooltip: true,
                    temp: 'html',
                    formatter: function (val) {
                        var str = [];
                        if (val) {
                            str = val.split(',');
                        }
                        else {
                            str = '-';
                        }
                        return str;
                    },
                },
                {
                    label: '账号状态',
                    tooltip: true,
                    prop: 'enable',
                    formatter: function (val) {
                        return val ? '启用中' : '禁用中';
                    },
                },
                {
                    label: '创建时间',
                    width: '200px',
                    prop: 'createTime',
                    tooltip: true,
                },
                {
                    label: '操作',
                    width: '230px',
                    prop: 'ope_control_group',
                    btns: [
                        {
                            name: '编辑',
                            formatter: function (val) {
                                return !val.isAmdin;
                            },
                            callback: function (row) {
                                _this.$store.dispatch('auth/GET_ACCOUNT_DETAIL', {
                                    userId: row.userId,
                                });
                            },
                            border: function () {
                                return false;
                            },
                        },
                        {
                            name: '禁用',
                            formatter: function (val) {
                                if (val.isAmdin) {
                                    return false;
                                }
                                else {
                                    return val.enable;
                                }
                            },
                            callback: function (row) {
                                _this.disableAccount(row);
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return btn[0].formatter(row);
                            },
                        },
                        {
                            name: '启用',
                            formatter: function (val) {
                                if (val.isAmdin) {
                                    return false;
                                }
                                else {
                                    return !val.enable;
                                }
                            },
                            callback: function (row) {
                                _this.disableAccount(row);
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return btn[1].formatter(row) || btn[0].formatter(row);
                            },
                        },
                        {
                            name: '删除',
                            formatter: function (val) {
                                return !val.isAmdin;
                            },
                            callback: function (row) {
                                _this.deleteAccount(row);
                            },
                            border: function (row) {
                                var btn = _this.tableConfig[_this.tableConfig.length - 1].btns;
                                return (btn[2].formatter(row) ||
                                    btn[1].formatter(row) ||
                                    btn[0].formatter(row));
                            },
                        },
                    ],
                },
            ],
            cellConfig: {
                enable: [
                    {
                        status: true,
                        style: 'color:#00ad90',
                    },
                    {
                        status: false,
                        style: 'color:#ff4263',
                    },
                ],
            },
        };
    },
    components: {
        'el-result-list': ResultList,
        'el-edit-role': editRole,
    },
    created: function () {
        this.$store.dispatch('auth/GET_ALL_ROLES');
        this.$store.dispatch('auth/GET_ALL_ACOUNTS');
    },
    computed: __assign({}, mapState('auth', {
        allRoles: 'allRoles',
        isShowAccountEditDialog: 'isShowAccountEditDialog',
        allAccountCounts: 'allAccountCounts',
    })),
    watch: {
        allRoles: function () {
            var _this = this;
            var data = this.$store.state.auth.allRoles;
            if (data && data.length) {
                data.forEach(function (element) {
                    var obj = {
                        label: '',
                        val: '',
                    };
                    obj.label = element.roleName;
                    obj.val = element.roleCode;
                    _this.searchConfig[1].option.push(obj);
                });
            }
        },
    },
    methods: {
        addAccount: function () {
            this.$router.push({
                path: '/console/user-manage/user-auth/add-account',
            });
        },
        disableAccount: function (item) {
            var _this = this;
            var title = item.enable
                ? '您确认要禁用该账号吗？'
                : '您确认要启用该账号吗？';
            var content = item.enable
                ? '禁用后，该用户将无法登录。'
                : '启用后，该用户可正常登录。';
            var className = item.enable ? 'self-confirm' : '';
            var buttonText = item.enable ? '禁用' : '启用';
            this.$confirm('', '', {
                message: "<p class=\"title\">" + title + "</p><p style=\"color:#41485D\">" + content + "</p>",
                dangerouslyUseHTMLString: true,
                showClose: true,
                confirmButtonText: buttonText,
                type: 'warning',
                customClass: className,
            })
                .then(function () {
                _this.$request({
                    url: '/proxy/auth/user/enable',
                    method: 'post',
                    data: {
                        userId: item.userId,
                        enabled: !item.enable,
                    },
                }).then(function (res) {
                    if (!res.errorCode) {
                        item.enable
                            ? _this.$message('该账号已禁用')
                            : _this.$message('该账号已启用');
                        eventBus.$emit('freshTable');
                    }
                    else {
                        _this.$message.error(res.errorMsg);
                    }
                });
            })
                .catch(function () { });
        },
        deleteAccount: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: '<p class="title">您确认要删除该账号吗？</p><p style="color:#41485D">删除后，该用户将无法登录。</p>',
                dangerouslyUseHTMLString: true,
                showClose: true,
                confirmButtonText: '删除',
                type: 'warning',
                customClass: 'self-confirm delete-confirm',
            })
                .then(function () {
                _this.$request({
                    url: '/proxy/auth/user/delete',
                    method: 'post',
                    data: {
                        userId: item.userId,
                    },
                }).then(function (res) {
                    if (!res.errorCode) {
                        _this.$message('该账号已删除');
                        eventBus.$emit('freshTable');
                        _this.$store.dispatch('auth/GET_ALL_ACOUNTS');
                    }
                    else {
                        _this.$message.error(res.errorMsg);
                    }
                });
            })
                .catch(function () { });
        },
    },
});
